import React from 'react';
import ResultToolbarPrimary from './ResultToolbarPrimary';
import ResultToolbarSecondary from './ResultToolbarSecondary';

export function ResultToolbarDefaultView(props) {
  return (
    <header id="main-content" aria-label="Results Toolbar" className="result-toolbar u-els-padding-top u-els-padding-bottom">
      <ResultToolbarPrimary {...props} />
      <ResultToolbarSecondary {...props} />
    </header>
  );
}

export default ResultToolbarDefaultView;
